module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    attrs: {
      "value": _vm.value
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.visible = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper",
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-container col-md-6",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    attrs: {
      "name": "header"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn-close",
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_c('i', {
    staticClass: "zmdi zmdi-close"
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.delete_type),
      expression: "!delete_type"
    }],
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-warning btn-lg",
    on: {
      "click": function($event) {
        _vm.delete_type = 'transfer'
      }
    }
  }, [_vm._v("\n\t              轉移交易，並封存聯絡人\n\t            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.delete_type == 'transfer'),
      expression: "delete_type=='transfer'"
    }],
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input"
  }, [_c('label', {
    attrs: {
      "for": "text"
    }
  }, [_vm._v("請輸入要移轉的聯絡人名稱，如果該聯絡人不存在，將會建立全新的聯絡人")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "url": _vm.axios.defaults.baseURL + '/settings/auto_complete',
      "anchor": "name",
      "label": "organization_name",
      "param": "keyword",
      "name": "autocomplete",
      "placeholder": "輸入並選擇聯絡人*",
      "classes": {
        input: 'form-control  contact_name',
        wrapper: 'input-wrapper'
      },
      "process": _vm.process_contact_JSON,
      "onSelect": _vm.handle_contact_Select,
      "onInput": _vm.set_contact_Value,
      "customHeaders": _vm.AuthToken,
      "customParams": {
        type: 'contact'
      }
    },
    model: {
      value: (_vm.contact_name),
      callback: function($$v) {
        _vm.contact_name = $$v
      },
      expression: "contact_name"
    }
  })], 1)]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.delete_type == 'destroy'),
      expression: "delete_type=='destroy'"
    }],
    staticClass: "font-weight-bold"
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-alert"
  }), _vm._v(" 永久封存後，將無法還原")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.delete_type),
      expression: "!delete_type"
    }],
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-lg",
    on: {
      "click": function($event) {
        _vm.delete_type = 'destroy'
      }
    }
  }, [_vm._v("\n\t             \t永久封存聯絡人與交易\n\t            ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.delete_type),
      expression: "delete_type"
    }],
    staticClass: "modal-footer j-forms col-md-12"
  }, [_c('div', {
    attrs: {
      "name": "footer"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.deleteTarget
    }
  }, [_vm._v("\n                  確認\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("\n                  取消\n                ")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body j-forms"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('h4', [_vm._v("聯絡人封存")]), _vm._v(" "), _c('h5', {
    staticClass: "alert alert-warning"
  }, [_vm._v("\n                  聯絡人離職後，可進行封存，請選擇永久封存 『聯絡人/公司』 之交易 或 將全部交易轉移至其他聯絡人"), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d33c806c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/DeleteModal.vue
// module id = 712
// module chunks = 4